import axios from "axios";
import { ElMessage } from "element-plus";
import { router } from "@/router/index";

import { useAppStoreWithOut } from "../store";
const appStore = useAppStoreWithOut();
const service = axios.create({
  //基础路径
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
  //请求超时时间   （3s内没响应就失败了）
  timeout: 30000,
});
//请求拦截器
service.interceptors.request.use(
  (config) => {
    //测试token
    const token = appStore.getAccessToken;
    config.headers["Authorization"] = token;
    return config;
  },
  (error) => {
    //请求失败的返回，后面的then或者catch回调随便写不写
    return Promise.reject(error);
  },
);

//响应拦截器
service.interceptors.response.use(
  (response) => {
    // 获取服务器时间 并保存到store 定时器时钟
    if (response.status === 200 && response.data.code === 0) {
      appStore.SET_CLOCK(new Date(response.headers.date).getTime());
      return response.data;
    } else if (response.data.code === 401) {
      router.push("/login");
      appStore.CLEAR_CACHE();
      ElMessage.error(response.data.msg);
      return Promise.reject(new Error(response.data.msg));
    } else {
      ElMessage.error(response.data.msg);
      return Promise.reject(new Error(response.data.msg));
    }
  },
  (error) => {
    ElMessage.error(error);
    return Promise.reject(error);
  },
);

//导出axios实例
export default service;
